import { Button } from '@mui/material';
import { useSnackbar } from 'notistack';
import { FC } from 'react';
import { navigateService } from '../../../services/navigate/navigate.service';

export const SnackbarLink: FC<ISnackbarLink> = ({ text, href, id }) => {
  const { closeSnackbar } = useSnackbar();

  const handleClick = () => {
    if (href) {
      navigateService.pub.navigateTo(href);
      closeSnackbar(id);
    }
  };

  return (
    <Button
      onClick={handleClick}
      variant='text'
      size='small'
      component='span'
      disableRipple
      sx={{
        ml: 0.5,
        p: 0,
        minWidth: 'auto',
        textTransform: 'none',
        textDecoration: 'underline',
        cursor: 'pointer',
      }}
    >
      {text}
    </Button>
  );
};

interface ISnackbarLink {
  text: string;
  href: string;
  id: string | number;
}
